import { useBlockProps } from '@wordpress/block-editor';

export default function Save( { attributes } ) {
  const { limit } = attributes;
  return (
    <div
      { ...useBlockProps.save() }
      className="seoninja-faqs-list"
      data-limit={ limit }
    >
      <p>Loading FAQs…</p>
    </div>
  );
}
